import React, { useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';

interface SaveViewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Pre-fill (e.g. from a shared link's sv_name). */
  defaultName?: string;
  /** Returns true if the save succeeded. */
  onSave: (name: string) => boolean;
}

export const SaveViewDialog = ({
  open,
  onOpenChange,
  defaultName = '',
  onSave,
}: SaveViewDialogProps) => {
  const [name, setName] = useState(defaultName);

  useEffect(() => {
    if (open) setName(defaultName);
  }, [open, defaultName]);

  const trimmed = name.trim();

  const handleSave = () => {
    if (!trimmed) return;
    if (onSave(trimmed)) onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Save current view</DialogTitle>
          <DialogDescription>
            Give it a name. Saved views are personal — share one with a link if someone else needs
            it.
          </DialogDescription>
        </DialogHeader>
        <Input
          autoFocus
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') handleSave();
          }}
          placeholder="e.g. My Review Roster"
          aria-label="View name"
        />
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={!trimmed}>
            Save view
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
